module.exports = {"phase":{"Building A":["Basement","0","1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","Roof"],"Building B":["Basement","0","1","2","3","4","5","6","7","Roof (Urban Farm)"],"C":["Other (specify below)"],"D":["Other (specify below)"],"E1":["Other (specify below)"],"E2":["Other (specify below)"],"F":["Other (specify below)"],"Site Wide":["Other (specify below)"],"Completed Area (Estates)":["Other (specify below)"]}}


//////////////////
// WEBPACK FOOTER
// ./src/data/camdenGoodsYard.json
// module id = 112
// module chunks = 0